import { TrackAvailabilityOptionDto } from '@cratehackers/api-client';
import { IonItemGroup } from '@ionic/react';
import React from 'react';
import './TrackDropdown.scss';
import { TrackDropdownItem } from './TrackDropdownItem';

interface TrackDropdownProps {
  artist: string;
  title: string;
  dropdownData: TrackAvailabilityOptionDto[];
}

export const TrackDropdown: React.FC<TrackDropdownProps> = ({
  artist,
  title,
  dropdownData,
}) => {
  return (
    <IonItemGroup className="dropdown-container">
      {dropdownData.map((dropdownItem, index) => {
        return (
          <TrackDropdownItem
            key={index}
            artist={artist}
            title={title}
            dropdownItem={dropdownItem}
          />
        );
      })}
    </IonItemGroup>
  );
};
